import { routes as admin } from "@/modules/admin";
import { routes as home } from "@/modules/home";
import { routes as log } from "@/modules/log";
import { routes as auth } from "@/modules/auth";
import { routes as usuario } from "@/modules/usuario";

export default [
  {
    path: "*",
    redirect: "/"
  },
  ...admin,
  ...home,
  ...log,
  ...auth,
  ...usuario
];
